import { updateFieldObjectAndDisable } from '../../util/updateFieldObject'
import { childrenFields, spouseFields } from '../common/FORM_SEGMENTS'
import { updateHealthQuestionAndCoverageAmountFields } from '../slice/form'
import _ from 'lodash'

export const mapToSegments = (state, eoiPayload) => {
  state.context.sessionLive = true
  state.segments.dependents.fields.spouseApplying = updateFieldObjectAndDisable(state, 'segments.dependents.fields.spouseApplying', eoiPayload.dependents.spouseApplying)
  state.segments.dependents.fields.childrenApplying = updateFieldObjectAndDisable(state, 'segments.dependents.fields.childrenApplying', eoiPayload.dependents.childrenApplying)
  if (eoiPayload.dependents.spouseApplying === 'yes') {
    state.segments.dependents.fields.spouse = spouseFields
  }
  if (eoiPayload.dependents.childrenApplying === 'yes') {
    state.segments.dependents.fields.children = eoiPayload.dependents.children.map(() => childrenFields)
  }
  updateHealthQuestionAndCoverageAmountFields(state)

  Array.of('employer', 'employee', 'dependents', 'coverageAmount').forEach(segment => {
    _.set(
      state,
      `segments.${segment}.fields`,
      Object.keys(eoiPayload[segment]).reduce((o, i) => {
        return i in o && eoiPayload[segment][i] ? {
          ...o,
          [i]: updateFieldObjectAndDisable(state, `segments.${segment}.fields.${i}`, eoiPayload[segment][i])
        } : o
      }, _.get(state, `segments.${segment}.fields`))
    )
  })

  updateHealthQuestionAndCoverageAmountFields(state)
}